import React, { Component } from "react";
import { orange } from "@material-ui/core/colors";

class MovilesCambioEstado extends Component {
  constructor(props) {
    super(props);

    this.dataService = "/llantas";
    this.state = {
      props: this.props,
      intl: this.props.intl,
      formulario: null,
      recapadoObservation: "",
      movil: this.props.movil,
      motivo: "",
      nuevoEstado: this.props.nuevoEstado,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.handleSubmitCambioEstado(this.state.nuevoEstado, this.state.motivo);
  }

  render() {
    return (
      <React.Fragment>
        <div className="p-1">
          <form className="form form-horizontal" onSubmit={this.handleSubmit}>
            <div className="text-center">
              <h3>
                <i className="fas fa-exclamation-circle mr-1" style={{color: orange}}></i>
                {this.state.intl.formatMessage({
                id: "MovilesCambioEstado.motivo_del_cambio_de_estado",
                defaultMessage: "Motivo del cambio de estado",
              })}</h3>
            </div>

            <hr />

            <div className="mb-3 mt-4">
              <p><b>{this.state.intl.formatMessage({ id: "MovilesCambioEstado.vehiculo", defaultMessage: "Vehículo" })}</b>: {this.props.modeloNombre ? (this.props.movil.dominio + ' - ' +  this.props.modeloNombre) : this.props.movil.dominio}</p>
              <p><b>{this.state.intl.formatMessage({ id: "MovilesCambioEstado.Unidad", defaultMessage: "Unidad" })}</b>: {this.state.movil.unidad}</p>
              <p><b>{this.state.intl.formatMessage({ id: "MovilesCambioEstado.estado_actual", defaultMessage: "Estado Actual" })}</b>: {this.state.movil.estado}</p>
              <p><b>{this.state.intl.formatMessage({ id: "MovilesCambioEstado.nuevo_estado", defaultMessage: "Nuevo Estado" })}</b>: {this.props.nuevoEstado}</p>
            </div>

            <div className="form-group">
              <label htmlFor="motivo">{this.state.intl.formatMessage({ id: "MovilesCambioEstado.motivo_del_cambio", defaultMessage: "Motivo del cambio" })}*</label>
              <textarea
                id="motivo"
                className="form-control"
                maxLength={250}
                required
                value={this.state.motivo}
                placeholder={this.state.intl.formatMessage({ id: "MovilesCambioEstado.motivo_del_cambio_placeholder", defaultMessage: "Ingrese el motivo de cambio de estado..." })}
                onChange={(e) => this.setState({ motivo: e.target.value })}
              />
              <p>{this.state.intl.formatMessage({ id: "MovilesCambioEstado.este_campo_es_obligatorio", defaultMessage: "Este campo es obligatorio y se registrara junto a la fecha, hora y usuario" })}</p>
            </div>
            <div className="text-center mt-4">
              <button
                type="button"
                className="btn btn-outline-secondary mr-2"
                onClick={this.props.handleModalCloseCambioEstado}
              >
                {this.state.intl.formatMessage({
                  id: "llantaAsignacionesDetails.render.button_cancelar",
                  defaultMessage: "Cancelar",
                })}
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={!this.state.motivo}
              >
                <i className="fa fa-check-circle"></i> {this.state.intl.formatMessage({
                  id: "llantaAsignacionesDetails.render.confirmar_cambio",
                  defaultMessage: "Confirmar Cambio",
                })}
              </button>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }
}

export default MovilesCambioEstado;
